export default __webpack_public_path__ + "static/media/compas_create_prospect.4e0422c8.gif";